import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Input } from "@ts-digital/vrc";
import "./style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import { Checkbox, Select, Space } from "antd";
import moment from "moment";
import FormElement from "./formElement";
import { VaporRangeDatePicker } from "../../../vapor";
import MovementsFilters from "./movementsFilters";

moment.locale("it"); // sets words language (optional if current locale is to be used)

const Option = Select.Option;

const Filter = ({
  setUuidCurrentFilter,
  filterChips,
  setFilterChips,
  docNumberFilter,
  setDocNumberFilter,
  accountCodeFilter,
  setAccountCodeFilter,
  movementsFiltersChips,
  setMovementsFiltersChips,
  includesFilter,
  onCheckIncludesFilter,
  onChangeDocDate,
  dateFrom,
  dateTo,
  setDateFrom,
  setDateTo,
  closeMoreFilter,
  setCloseMoreFilter,
  monthsSelectValue,
  setMonthsSelectValue,
  months,
  setMonths,
  yearFilter,
  setYearFilter,
  quarterFilter,
  setQuarterFilter,
  isBankTransactionActive,
  setIsBankTransactionActive,
  tabActive
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    // i mesi non cambiano. Evitiamo inutili refresh
    const rawMonths = moment.months();
    const months = rawMonths.map(m => m.charAt(0).toUpperCase() + m.slice(1));
    const allMonths = ["Tutti", ...months];
    setMonths(allMonths);
  }, []);

  useEffect(() => {
    const activeChips = filterChips.filter(ch => ch.active);
    const keys = activeChips.map(ac => ac.key);
    setIsBankTransactionActive(keys.includes("BANK_TRANSACTION") ? true : false);
  }, [filterChips]);

  useEffect(() => {
    let fromDate = "";
    let toDate = "";

    if (quarterFilter === "Mese") {
      if (monthsSelectValue?.length === 0 || monthsSelectValue === 0) return;
      if (monthsSelectValue === 1 || monthsSelectValue === undefined) {
        fromDate = moment(new Date(
          yearFilter, 0, 1
        ));
        toDate = moment(new Date(
          yearFilter, 12, 0
        ));
      } else {
        fromDate = moment(new Date(
          yearFilter, monthsSelectValue - 2, 1
        ));
        toDate = moment(new Date(
          yearFilter, monthsSelectValue -1, 0
        ));
      }
    }

    if (quarterFilter === "Trimestre") {
      if (monthsSelectValue?.length === 0 || monthsSelectValue === 0) return;
      if (monthsSelectValue === 1 || monthsSelectValue === undefined) {
        fromDate = moment(new Date(
          yearFilter, 0, 1
        ));
        toDate = moment(new Date(
          yearFilter, 12, 0
        ));
      } else {
        fromDate = moment(new Date(
          yearFilter, (monthsSelectValue - 2) * 3, 1
        ));
        toDate = moment(new Date(
          yearFilter, ((monthsSelectValue -1) * 3), 0
        ));
      }
    }
    if (quarterFilter === "Semestre") {
      if (monthsSelectValue?.length === 0 || monthsSelectValue === 0) return;
      if (monthsSelectValue === 1 || monthsSelectValue === undefined) {
        fromDate = moment(new Date(
          yearFilter, 0, 1
        ));
        toDate = moment(new Date(
          yearFilter, 12, 0
        ));
      } else {
        fromDate = moment(new Date(
          yearFilter, (monthsSelectValue - 2) * 6, 1
        ));
        toDate = moment(new Date(
          yearFilter, ((monthsSelectValue - 1) * 6), 0
        ));
      }
    }

    if (fromDate !== "" && toDate !== "") {

      setDateFrom(moment(fromDate).format("YYYY-MM-DD"));
      setDateTo(moment(toDate).format("YYYY-MM-DD"));
    }
  }, [monthsSelectValue, quarterFilter, yearFilter]);

  const quarters = [
    {
      value: "Tutti",
      index: 1
    },
    {
      value: "Primo",
      index: 2
    },
    {
      value: "Secondo",
      index: 3
    },
    {
      value: "Terzo",
      index: 4
    },
    {
      value: "Quarto",
      index: 5
    }
  ];

  const semesters = [
    {
      value: "Tutti",
      index: 1
    },
    {
      value: "Primo",
      index: 2
    },
    {
      value: "Secondo",
      index: 3
    }
  ];

  const monthsList = [];
  const quartersList = [];
  const semestersList = [];

  for (let i = 0; i < months.length; i++) {
    monthsList.push(<Option
      key={"monthOpt_" + months[i]}
      value={i + 1}
      label={months[i]}
    >
      <div className="monthsSelection">
        <span style={{marginLeft: "8px"}}>{months[i]}</span>
      </div>
    </Option>);
  }

  for (let i = 0; i < quarters.length; i++) {
    quartersList.push(<Option
      key={"quartOpt_" + quarters[i].index}
      value={quarters[i].index}
      label={quarters[i].value}
    >
      <div className="quartersSelection">
        <span style={{marginLeft: "8px"}}>{quarters[i].value}</span>
      </div>
    </Option>);
  }

  for (let i = 0; i < semesters.length; i++) {
    semestersList.push(<Option
      key={"semOpt_" + semesters[i].index}
      value={semesters[i].index}
      label={semesters[i].value}
    >
      <div className="semestersSelection">
        <span style={{marginLeft: "8px"}}>{semesters[i].value}</span>
      </div>
    </Option>);
  }

  const renderOptionYear = () => {
    const currentYear = (new Date()).getFullYear();
    const arrayOptionYears = [<Option key={"all"} value={""}>
      Tutti
    </Option>];
    /** ho deciso che offro una select da quest'anno agli anni  */
    for (let year = currentYear - 10; year <= currentYear; year++ ){
      arrayOptionYears.push( <Option key={year} value={year}>
        {year}
      </Option>);
    }
    return arrayOptionYears.reverse();

  };

  const renderTimeType = () => {
    const timeType = ["Mese", "Trimestre", "Semestre"];
    const arrayOptionTimeType = [];
    /** ho deciso che offro una select da quest'anno agli anni  */
    for (let i = 0; i < timeType.length; i++ ){
      arrayOptionTimeType.push( <Option key={"time_"+i} value={timeType[i]}>
        {timeType[i]}
      </Option>);
    }
    return arrayOptionTimeType;
  };

  const onChangeFinalPeriod = newValue => {
    setMonthsSelectValue(newValue);
  };

  const selectMonthProps = {
    style: { width: "100%" },
    dropdownClassName: "monthSelectOpts",
    className: "monthSelectValue",
    defaultValue: monthsSelectValue,
    allowClear: true,
    value: monthsSelectValue,
    onChange: (newValue) => {
      onChangeFinalPeriod(newValue);
    },
    placeholder: quarterFilter === "Mese" ? "Seleziona mese" : quarterFilter === "Trimestre" ? "Seleziona trimestre" : "Seleziona semestre",
    optionLabelProp:"label"
  };

  const calculatedWidth = () => {
    if (yearFilter === null && quarterFilter === null) {
      return "50%";
    } else if (yearFilter !== null && quarterFilter === null) {
      return "70%";
    }
    return "100%";
  };

  return (
    <div /** TODO when chips recover we cancel the style */  style={{position: "relative"}}>
      <div className="toAccountedForFilterBlock" /** TODO when chips recover we cancel the style */ style={{position: "absolute",
        right: 0}}>
        <div style={{display: "flex", alignItems: "flex-start"}}>

        </div>

        <Button style={{marginTop: "4px"}} colorScheme={"ghost"} kind={"secondary"} onClick={() => navigate("/precog-create")}>
          <div style={{display: "flex", alignItems: "center"}}>
            <FontAwesomeIcon icon={["fal", "plus-circle"]} style={{
              color: "#0090d1",
              fontSize: "16px",
              cursor: "pointer",
              marginRight: "8px"
            }}  />
            <FormattedMessage id="preCog.createAccountingRecord" />
          </div>
        </Button>
      </div>
      {
        (!closeMoreFilter || tabActive === 2) &&
        <div className="moreContainer" /** TODO when chips recover we cancel the style */  style={{marginTop: "32px"}}>
          <div style={{display: "flex", width: calculatedWidth()}}>
            <FormElement label="Data documento" style={{flexGrow: 1}}>
              <VaporRangeDatePicker
                getPopupContainer={trigger => trigger.parentNode}
                id="pre-cog-detail-input-9"
                style={{ marginTop: 4, width: "100%" }}
                onChange={value => {
                  onChangeDocDate(value);
                }}
                value={[dateFrom ? moment(dateFrom) : null, dateTo ? moment(dateTo) : null]}
              />
            </FormElement>
            <FormElement label="Numero documento"  style={{flexGrow: 1}}>
              <Input
                label={""}
                onChange={value => {
                  setDocNumberFilter(value);
                }}
                value={docNumberFilter}
                disabled={tabActive === 2}
              />
            </FormElement>

            <FormElement label="Seleziona anno">
              <Select
                placeholder={"Scegli l'anno"}
                getPopupContainer={trigger => document.getElementById("dbx-main-container")}
                style={{marginTop: "5px"}}
                value={yearFilter}
                allowClear
                onChange={value => {
                  if (!value) setYearFilter(null);
                  setYearFilter(value);
                }}
                disabled={tabActive === 2}
              >
                {renderOptionYear()}
              </Select>
            </FormElement>

            {yearFilter !== null &&
              <FormElement label="Seleziona"  style={{flexGrow: 1}}>
                <Select
                  allowClear
                  getPopupContainer={trigger => trigger.parentNode}
                  style={{marginTop: "5px"}}
                  placeholder={"Seleziona periodo"}
                  value={quarterFilter}
                  onChange={value => {
                    setQuarterFilter(value);
                    setMonthsSelectValue(1);
                  }}
                >
                  {renderTimeType()}
                </Select>
              </FormElement>
            }

            {quarterFilter !== null &&
              <FormElement label={quarterFilter === "Mese" ? "Seleziona mese" : quarterFilter === "Trimestre" ? "Seleziona trimestre" : "Seleziona semestre"} style={{flexGrow: 0}}>
                <Space direction="vertical" style={{ width: "300px", marginTop: "5px"}}>
                  <Select {...selectMonthProps}
                    getPopupContainer={trigger => trigger.parentNode}
                  >
                    {quarterFilter === "Mese" ?
                      monthsList
                      : quarterFilter === "Trimestre" ?
                        quartersList
                        : semestersList
                    }
                  </Select>
                </Space>
              </FormElement>
            }

          </div>
          <div className="second-row-filters-containers">
            <div style={{marginTop: "24px", width: "40%"}}>
              <FormElement label="Documenti con" style={{flexGrow: 0}}>
                <div style={{display: "flex"}}>
                  <div className="filterCheckboxCol">
                    <Checkbox onChange={e => onCheckIncludesFilter(e, "WITHHOLDING")}
                      checked={includesFilter.includes("WITHHOLDING") }>Ritenute</Checkbox>
                    <Checkbox onChange={e => onCheckIncludesFilter(e, "ASSET")} checked={includesFilter.includes("ASSET")}>Cespiti</Checkbox>
                    <Checkbox onChange={e => onCheckIncludesFilter(e, "ACCOUNTING")} checked={includesFilter.includes("ACCOUNTING")}>Contabilita</Checkbox>
                  </div>
                  <div className="filterCheckboxCol">
                    <Checkbox onChange={e => onCheckIncludesFilter(e, "INTRASTAT")} checked={includesFilter.includes("INTRASTAT")}>Intrastat</Checkbox>
                    <Checkbox onChange={e => onCheckIncludesFilter(e, "VAT")} checked={includesFilter.includes("VAT")}>IVA</Checkbox>
                    <Checkbox onChange={e => onCheckIncludesFilter(e, "FISCAL_PAYMENT")} checked={includesFilter.includes("FISCAL_PAYMENT")}>Pagamento fiscale</Checkbox>
                  </div>
                  {/* <div className="filterCheckboxCol">
                    <Checkbox>Reverse charge (6)</Checkbox>
                    <Checkbox>Fattura differita (3)</Checkbox>
                  </div> */}
                </div>
              </FormElement>
            </div>

            {isBankTransactionActive && <MovementsFilters
              accountCodeFilter={accountCodeFilter}
              setAccountCodeFilter={setAccountCodeFilter}
              movementsFiltersChips={movementsFiltersChips}
              setMovementsFiltersChips={setMovementsFiltersChips}
            />
            }
          </div>
        </div>
      }

    </div>
  );
};

export default Filter;
